import { z } from 'zod';

import { successOpenApiDescription } from '../../constants/schemas.constants';
import { onlySuccessSchema } from '../base.schema';
import { categorySchema } from './category.schema';

export const categoryListResponseSchemaRef = 'categoryListResponse';

export const categoryListResponseSchema = z
	.object({
		success: z.boolean().meta(successOpenApiDescription),
		categories: z.array(categorySchema).meta({
			description: 'List of categories retrieved from the database.',
			example: [
				{
					id: 'aew8h2f23f98h32',
					name: 'Plants',
					description:
						'A collection of various plants and gardening supplies.',
					imageId: '248fhuo283hrp23/13r8h',
					menuDisplay: true,
					createdAt: '2023-10-01T12:00:00Z',
					updatedAt: '2023-10-01T12:00:00Z',
				},
			],
		}),
	})
	.meta({
		description: 'Schema for the response of the category list endpoint.',
		ref: categoryListResponseSchemaRef,
	})
	.strip();

export type CategoryListResponseSchemaType = z.infer<
	typeof categoryListResponseSchema
>;

export const categoryResponseSchemaRef = 'categoryResponse';

export const categoryResponseSchema = z
	.object({
		success: z.boolean().meta(successOpenApiDescription),
		category: categorySchema,
	})
	.meta({
		description: 'Schema for the response of a category',
		ref: categoryResponseSchemaRef,
	})
	.strip();

export type CategoryResponseSchemaType = z.infer<typeof categoryResponseSchema>;

export const removeCategoryResponseSchemaRef = 'removeCategoryResponse';

export const removeCategoryResponseSchema = onlySuccessSchema
	.meta({
		description: 'Schema for the response of removing a category',
		ref: removeCategoryResponseSchemaRef,
	})
	.strip();

export type RemoveCategoryResponseSchemaType = z.infer<
	typeof removeCategoryResponseSchema
>;
